<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('invoice-copy-header') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-if="debt.invoiceCopyRequested !== null">
      <v-row justify="center">
        <v-col class="shrink">
          <v-icon :size="100" color="color-green">
            fas fa-info-circle
          </v-icon>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="text-center">
          <h3 class="mt-4 text-h3">{{ $t('invoice-copy-header-existing') }}</h3>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" sm="10">
          <v-row justify="center">
            <v-col cols="4" sm="2">
              <p class="ok-title">{{ $t('debt') }}</p>
              <p class="ok-subtitle small" data-matomo-mask>{{ debt.orderNr }}</p>
            </v-col>
            <v-col cols="4" sm="3">
              <p class="ok-title">{{ $t('creditor') }}</p>
              <p class="ok-subtitle small">{{ debt.creditor.name }}</p>
            </v-col>
            <v-col cols="4" sm="2" v-if="bills.length === 1">
              <p class="ok-title">{{ $t('billNr') }}</p>
              <p class="ok-subtitle small" data-matomo-mask>{{ bills[0].referenceNr }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <v-col cols="12" sm="10">
          <p>{{ $t('invoice-copy-existing-desc-1') }}{{ debt.invoiceRequested | formatDate }}</p>
          <p>{{ $t('invoice-copy-existing-desc-2') }}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn tile color="primary" class="wide-button" @click="$emit('close')">
          <span>{{ $t('close') }}</span>
        </v-btn>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid v-else>
      <fade-transition mode="out-in">
        <v-row no-gutters key="phase-1" v-if="phase === 1">
          <v-col>
            <v-container class="pa-0" fluid>
              <v-row justify="center">
                <v-col cols="12" sm="10" class="text-center">
                  <h3 class="text-h3 mt-0" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('invoice-copy-header') }}</h3>
                </v-col>
                <v-col cols="12" sm="10">
                  <p>{{ $t('phase-1-desc-1') }}</p>
                  <p>{{ $t('phase-1-desc-2') }}</p>
                </v-col>
              </v-row>
              <v-row justify="center" class="mb-4">
                <div class="pa-3">
                  <v-btn tile class="primary wide-button" @click="phase = 2">
                    {{ $t('invoice-copy-start') }}
                  </v-btn>
                </div>
                <div class="pa-3">
                  <v-btn tile outlined color="color-new-link-blue" class="wide-button" @click="$emit('close')">
                    <span>{{ $t('cancel') }}</span>
                  </v-btn>
                </div>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="9">
                  <v-row align="center">
                    <v-col class="shrink">
                      <v-icon>fas fa-info-circle</v-icon>
                    </v-col>
                    <v-col>
                      <span class="text-body-2">{{ $t('phase-1-desc-3') }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

        <v-row no-gutters key="phase-2" v-if="phase === 2">
          <v-col>
            <v-container class="pa-0" fluid>
              <v-row justify="center">
                <h3 class="mt-0 text-h3" v-if="$vuetify.breakpoint.mdAndUp">{{ $t('invoice-copy-header') }}</h3>
              </v-row>
              <v-row no-gutters justify="center">
                <v-col cols="12" sm="10">
                  <v-row justify="center">
                    <v-col cols="12" sm="3">
                      <p class="ok-title">{{ $t('debt') }}</p>
                      <p class="ok-subtitle small" data-matomo-mask>{{ debt.orderNr }}</p>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <p class="ok-title">{{ $t('creditor') }}</p>
                      <p class="ok-subtitle small">{{ debt.creditor.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="3" v-if="bills.length === 1">
                      <p class="ok-title">{{ $t('billNr') }}</p>
                      <p class="ok-subtitle small">{{ bills[0].referenceNr }}</p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-if="bills.length > 1" justify="center">
                <v-col cols="12" sm="8">
                  <span class="ok-title color-new-link-blue--text">{{ $t('invoice-copy-sub-header') }}</span>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-data-table v-model="selected"
                                :headers="headers"
                                :items="bills"
                                item-key="nr"
                                show-select
                                :items-per-page="-1"
                                hide-default-footer>
                    <template #item.dueDate="{ item }">
                      {{ item.dueDate | formatDate }}
                    </template>
                    <template #item.total="{ item }">
                      {{ item.total | currency }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row justify="center" align="end">
                <v-col cols="12" class="pa-0">
                  <h3 class="text-center">
                    {{ $t('invoice-copy-email-header') }}
                  </h3>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <p class="ok-title">
                    {{ $t('email') }}
                  </p>
                  <v-text-field v-model="email"
                                :label="$t('emailAddress')"
                                @blur="$v.email.$touch()"
                                @change="$v.email.$touch()"
                                :error-messages="emailError"
                                outlined />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <p class="ok-title">
                    {{ $t('invoice-copy-email-header-2') }}
                  </p>
                  <v-text-field v-model="confirmEmail"
                                :label="$t('emailAddress')"
                                @blur="$v.confirmEmail.$touch()"
                                @change="$v.confirmEmail.$touch()"
                                :error-messages="confirmEmailError"
                                outlined />
                </v-col>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn tile class="primary wide-button" @click="requestInvoicesCopy" :disabled="!isValid || loading" :loading="loading">
                    {{ $t('invoice-copy-confirm') }}
                  </v-btn>
                </div>
                <div class="pa-3">
                  <v-btn tile outlined color="color-new-link-blue" class="wide-button" @click="$emit('close')">
                    <span>{{ $t('cancel') }}</span>
                  </v-btn>
                </div>
              </v-row>

            </v-container>
          </v-col>
        </v-row>

        <v-row no-gutters key="phase-3" v-if="phase === 3" justify="center">
          <v-col cols="12" sm="10">
            <v-container class="pa-0" fluid>
              <v-row justify="center">
                <v-col class="shrink">
                  <v-icon :size="100" color="color-green">
                    fa-check
                  </v-icon>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="text-center">
                  <h3 class="mt-4 text-h3">{{ $t('invoice-copy-header-done') }}</h3>
                </v-col>
                <v-col cols="12" sm="10">
                  <p v-if="transferedDueDate !== null">{{ $t('invoice-copy-done-duedate') }}{{ transferedDueDate | formatDate }}</p>
                  <p>{{ $t('invoice-copy-done-desc-1') }}</p>
                  <p>{{ $t('invoice-copy-done-desc-2') }}</p>
                </v-col>
              </v-row>
              <v-row justify="center" class="text-center">
                <shared-customer-feedback :orderNr="debt.orderNr" :type="4" @close="$emit('close')"></shared-customer-feedback>
              </v-row>
              <v-row justify="center">
                <div class="pa-3">
                  <v-btn tile color="primary" class="wide-button" @click="$emit('close')">
                    <span>{{ $t('close') }}</span>
                  </v-btn>
                </div>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

      </fade-transition>
    </v-container>
  </v-card>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { required, email, sameAs } from 'vuelidate/lib/validators'

  export default {
    props: ['debt'],
    data: function () {
      return {
        phase: 1,
        selected: [],
        email: '',
        confirmEmail: '',
        transferedDueDate: null
      }
    },
    mounted () {
      if (this.debt.invoiceCopyRequested !== null) {
        this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice In Progress")
      }
    },
    computed: {
      bills () {
        return this.debt.bills.filter(function (bill) {
          return bill.type === 1
        })
      },
      loading () {
        return this.$store.getters.loading
      },
      headers () {
        let desktopHeaders = [
          { text: this.$t('dueDate'), value: 'dueDate' },
          { text: this.$t('debtAmount'), value: 'total' },
          { text: this.$t('billNr'), value: 'referenceNr' }
        ]

        /* let mobileHeaders = [
          { text: this.$t('dueDate'), value: 'dueDate' },
          { text: '', value: '' }
        ] */

        return desktopHeaders
      },
      isValid () {
        if (!this.$v.email.$error && this.$v.email.$dirty && !this.$v.confirmEmail.$error && this.$v.confirmEmail.$dirty) {
          if (this.selected.length > 0 || this.bills.length === 1) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      emailError () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.required && errors.push(this.$t('validation.email.required'))
        !this.$v.email.email && errors.push(this.$t('validation.email.email'))
        return errors
      },
      confirmEmailError () {
        const errors = []
        if (!this.$v.confirmEmail.$dirty) return errors
        !this.$v.confirmEmail.required && errors.push(this.$t('validation.email.required'))
        !this.$v.confirmEmail.sameAs && errors.push(this.$t('validation.email.sameAs'))
        return errors
      }
    },
    watch: {
      selected: function () {
        if (this.selected.length > 0) {
          this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice Select")
        }
      }
    },
    methods: {
      requestInvoicesCopy () {
        if (this.isValid) {
          this.$store.commit('setLoading', true)
          this.transferedDueDate = null
          let billNrs = this.bills.length === 1 ? this.bills.map(function (b) { return b.nr }) : this.selected.map(function (b) { return b.nr })
          let payload = { orderNr: this.debt.nr, billNrs: billNrs, email: this.email }

          apiResource.post('api/orders/invoiceCopyRequest', payload).then((response) => {
            this.$store.commit('setLoading', false)

            if (response.data.status === 0) {
              if (response.data.responseObject.key > 0) {
                this.transferedDueDate = response.data.responseObject.value
                this.phase = 3

                if (this.transferedDueDate !== null) {
                  this.$store.commit('setDueDate', { DebtNr: this.debt.orderNr, NewDuedate: this.transferedDueDate })
                }

                this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice Sent")
              } else if (response.data.responseObject.key === 0) {
                this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
                this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice Failed")
              }
            } else {
              this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
              this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice Failed")
            }
          }).catch((errorResponse) => {
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
            this.$store.commit('setLoading', false)
            this.$matomo && this.$matomo.trackEvent("Action", "Request Invoice", "Invoice Failed")
          })
        }
      }
    },
    validations: {
      email: {
        required,
        email
      },
      confirmEmail: {
        required,
        sameAs: sameAs('email')
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "invoice-copy-header": "Tilaa laskukopio",
  "phase-1-desc-1": "Voit nyt tilata laskukopion Oma B2 Impact -palvelun kautta. Pyyntö toimitetaan  toimeksiantajalle, ja laskukopio lähetetään sinulle sähköpostitse noin viikon kuluessa. Mikäli et ole saanut laskukopiota kahden viikon kuluessa, ota yhteys asiakaspalveluumme.",
  "phase-1-desc-2": "Tilaaminen ei pysäytä muistutuksen tai perinnän etenemistä. Mikäli haluat tehdä reklamaation, olethan yhteydessä asiakaspalveluumme.",
  "phase-1-desc-3": "Laskukopiopyyntö on alkuperäisen laskun kopio, ei perintäkirje. Mikäli haluat nähdä yhteenvedon velastasi, se löytyy Velan tiedot -välilehdeltä.",
  "invoice-copy-sub-header": "Valitse yksi tai useampi lasku, josta haluat kopion:",
  "invoice-copy-email-header": "Syötä sähköpostiosoite, johon laskukopio toimitetaan:",
  "invoice-copy-email-header-2": "Syötä sähköpostiosoite uudelleen:",
  "invoice-copy-confirm": "Tilaa laskukopio",
  "invoice-copy-start": "Aloita",
  "invoice-copy-header-done": "Laskukopio tilattu",
  "invoice-copy-header-existing": "Laskukopio on jo tilattu",
  "invoice-copy-existing-desc-1": "Tästä velasta on jo tehty laskukopiopyyntö ",
  "invoice-copy-existing-desc-2": "Toimitamme laskukopion antamaasi sähköpostiosoitteeseen, kun saamme tiedot toimeksiantajalta. ",
  "invoice-copy-done-desc-1": "Toimitamme laskukopion antamaasi sähköpostiin PDF-muodossa noin viikon kuluessa.",
  "invoice-copy-done-desc-2": "Mikäli et ole saanut laskukopiota kahden viikon kuluessa, ota yhteys asiakaspalveluumme.",
  "invoice-copy-done-duedate": "Toimeksiannnon eräpäivää on siirretty: "
  },
  "se": {
  "invoice-copy-header": "Begär en fakturakopia",
  "phase-1-desc-1": "Du kan nu begära fakturakopior via Min B2 Impact -tjänsten. Begäran vidarebefordras till vår uppdragsgivare och fakturakopian skickas till dig inom ca. en vecka. Kontakta vår kundtjänst ifall du inte fått kopian inom två veckor.",
  "phase-1-desc-2": "En begäran av fakturakopia hindrar inte påminnelse- eller indrivningsåtgärder. Om du vill reklamera fordran, vänligen kontakta vår kundtjänst.",
  "phase-1-desc-3": "Fakturakopior kan begäras på orginalfakturorna, inte på indrivningsbreven. Ett sammandrag av skulden hittar du under Skuldinformation-mellanbladet.",
  "invoice-copy-sub-header": "Välja faktura:",
  "invoice-copy-email-header": "Mata in den e-postadress dit fakturakopian skall levereras:",
  "invoice-copy-email-header-2": "Mata in e-postadressen på nytt:",
  "invoice-copy-confirm": "Begär fakturakopia",
  "invoice-copy-start": "Start",
  "invoice-copy-header-done": "Fakturakopia begärd",
  "invoice-copy-header-existing": "En begäran av fakturakopia har redan gjorts",
  "invoice-copy-existing-desc-1": "En begäran av fakturakopia på denna skuld har redan gjorts.",
  "invoice-copy-existing-desc-2": "Vi levererar kopian till den angivna e-postadressen när vi fått den av vår uppdragsgivare.",
  "invoice-copy-done-desc-1": "Vi levererar fakturakopian i PDF-format till den angivna e-postadressen inom ca. en vecka.",
  "invoice-copy-done-desc-2": "Kontakta vår kundtjänst ifall du inte har fått kopian inom två veckor.",
  "invoice-copy-done-duedate": "Förfallodag i ärendet har flyttats: "
  },
  "en": {
  "invoice-copy-header": "Request a copy of invoice",
  "phase-1-desc-1": "It is now possible to request a copy of original invoice via My B2 Impact service. The request will be forwarded to the creditor, and the invoice will be delivered to your email within a week. If you haven't received your copy within two weeks, contact our customer service.",
  "phase-1-desc-2": "Be advised that ordering a copy of the invoice does not stop the debt collection process. If you wish to file a complaint, please contact our customer service.",
  "phase-1-desc-3": "Note that the invoice copy is not equivalent to the debt collection notice. You can find the status of your debt under the \"Debt information\" tab.",
  "invoice-copy-sub-header": "Select invoice(s):",
  "invoice-copy-email-header": "Provide an email address where a copy will be delivered:",
  "invoice-copy-email-header-2": "Please verify the email address:",
  "invoice-copy-confirm": "Request a copy of invoice",
  "invoice-copy-start": "Start",
  "invoice-copy-header-done": "Copy of invoice requested",
  "invoice-copy-header-existing": "Invoice request is in progress",
  "invoice-copy-existing-desc-1": "A copy of original invoice has already been requested ",
  "invoice-copy-existing-desc-2": "Once we receive the required information from the creditor, the invoice will be delivered to the provided email address. ",
  "invoice-copy-done-desc-1": "The copy will be sent within a week in PDF format to the provided email address.",
  "invoice-copy-done-desc-2": "If you haven't received your copy within two weeks, please contact our customer service.",
  "invoice-copy-done-duedate": "The duedate has been transferred: "
  }
  }
</i18n>
